import { render, staticRenderFns } from "./Multipane.vue?vue&type=template&id=30bb1aa0&"
import script from "./Multipane.vue?vue&type=script&lang=js&"
export * from "./Multipane.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports